$(document).ready(function() {
    $('.accordion-button').click(function() {
        var icon = $(this).find('.icon');
        var content = $(this).siblings('.accordion-content');
        
        if ($(this).hasClass('active')) {
            icon.css('transform', 'rotate(0deg)');
            icon.css('background-color', 'red')
            content.css('display', 'none');
        } else {
            icon.css('transform', 'rotate(180deg)');
  
            content.css('display', 'block');
        }
        
        $(this).toggleClass('active');
    });
});
